<div class="change-password-box">
    <hr>
    <form *ngIf="data"
          #form="ngForm"
          (submit)="onChangePasswordSubmit(form)"
          [ngClass]="{'ng-submitted': form.submitted}"
          autocomplete="off">
        <div class="row m-b-xs">
            <div class="dv-label strong col-sm-4">
                Current Password
            </div>
            <div class="dv-value col-sm-6">
                <input class="form-control"
                       name="current_password"
                       type="password"
                       title="Current Password"
                       [(ngModel)]="data.current_password"
                       required>
            </div>
        </div>

        <div class="row m-b-xs">
            <div class="dv-label strong col-sm-4">
                New Password
            </div>
            <div class="dv-value col-sm-6">
                <input class="form-control"
                       name="plainPassword"
                       type="password"
                       title="New Password"
                       id="user_password_first"
                       (focus)="onFocusInput($event)"
                       (blur)="onBlurInput($event)"
                       (input)="validate($event)"
                       [(ngModel)]="data.plainPassword.first"
                       required>
            </div>
        </div>

        <div class="row m-b-md">
            <div class="dv-label strong col-sm-4">
                Confirm Password
            </div>
            <div class="dv-value col-sm-6">
                <input class="form-control"
                       name="plainPasswordConfirm"
                       type="password"
                       title="Confirm Password"
                       id="user_password_second"
                       (focus)="onFocusInput($event)"
                       (blur)="onBlurInput($event)"
                       (input)="validate($event)"
                       [(ngModel)]="data.plainPassword.second"
                       required>
            </div>
        </div>

        <div class="row m-b-sm password-controls">
            <div class="buttons col-sm-12">
                <button type="button" (click)="toggleChangePasswordForm(form)" class="btn btn-w-m btn-default-green">
                    Cancel
                </button>
                <button type="submit" class="btn btn-w-m btn-primary" [disabled]="profile.disabledSubmit">
                    Save Password
                </button>
            </div>
        </div>

        <div *ngIf="isActiveFirst || isActiveSecond"
             class="tooltip-validator"
             [ngClass]="{'active-first': isActiveFirst, 'active-second': isActiveSecond}">
            <div class="rules-box">
                <h4 class="title">Password Rules</h4>
                <p class="rules-content">Password can't contain parts of the user's full name</p>
            </div>
            <div class="rules-box">
                <h4 class="title">Must Contain:</h4>
                <ul class="rules-checklist">
                    <li class="rule length-rule" [ngClass]="{'passed': lengthPassed}">At least 6 characters</li>
                    <li class="rule uppercase-rule" [ngClass]="{'passed': upperPassed}">Uppercase Letter(s)</li>
                    <li class="rule lowercase-rule" [ngClass]="{'passed': lowerPassed}">Lowercase Letter(s)</li>
                    <li class="rule number-rule" [ngClass]="{'passed': numberPassed}">Number(s)</li>
                </ul>
            </div>
        </div>
    </form>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/profile/change-password/change-password.component.html